module.exports = {
      id: "jpy-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#jpy-usage",
      toString: function () {
        return this.url;
      }
    }